<!-- text -->
@if (isTextType) {
	<div class="form-filed-wrapper">
	<mat-form-field appearance="outline">
		<mat-label>{{ label }}</mat-label>
		<input cdkFocusInitial #field name="input" data-test-id="one-value-text-input"
		       matInput [required]="required" type="text" [formControl]="fieldControl" [readonly]="readonly"
		       (keyup)="onChange(field.value)" [errorStateMatcher]="evaluateAfterChange? matcher: null">
		@if (!readonly) {
			<button type="button" class="clear-button" matSuffix mat-icon-button
		        matTooltip="Eingabe löschen"
		        [attr.aria-label]="'Im Eingabefeld '+ label"
		        (click)="clearField(fieldControl,$event)" data-test-id="delete-button">
			<mat-icon>close</mat-icon>
		</button>
		}
		<mat-error class="errorMessage">
			@if (fieldControl?.invalid) {
				<span class="material-icons">error</span>
			}
			<span data-test-id="one-value-editor-error-message">{{ errorMessages }}</span>
		</mat-error>
	</mat-form-field>
</div>
}

<!-- long text -->
@if (isLongTextType) {
	<div class="form-filed-wrapper" data-test-id="one-value-longtext-field">
	<mat-form-field appearance="outline" data-test-id="one-value-text-field">
		<mat-label>{{ label }}</mat-label>
		<textarea #field cdkFocusInitial data-test-id="one-value-text-input" id="one-value-textarea-input" matInput
		          [required]="required" [formControl]="fieldControl"
		          (ngModelChange)="onChange(field.value)"></textarea>
		<mat-error class="errorMessage">
			@if (fieldControl?.invalid) {
				<span class="material-icons">error</span>
			}
			<span data-test-id="one-value-editor-error-message">{{ errorMessages }}</span>
		</mat-error>
	</mat-form-field>
</div>
}

<!-- numeric -->
@if (isNumberType) {
	<div>
	<mat-form-field appearance="outline">
		<mat-label>{{ label }}</mat-label>
		<input #field cdkFocusInitial data-test-id="one-value-numeric-input" matInput type="number" min="0"
		       step="{{stepsize}}" lang="de"
		       [formControl]="fieldControl" [readonly]="readonly" [required]="required"
		       (keyup)="onChange(field.value)" class="no-stepper">
		<mat-error class="errorMessage">
			@if (fieldControl?.invalid) {
				<span class="material-icons">error</span>
			}
			<span data-test-id="one-value-error-pattern-number">{{ errorMessages }}</span>
		</mat-error>
	</mat-form-field>
</div>
}

<!-- dropdown -->
@if (isSelectType) {
	<mat-form-field appearance="outline">
	<mat-label>{{ label }}</mat-label>
		@if (!readonly) {
			<mat-select cdkFocusInitial class="select" [placeholder]="label" [required]="required"
	            [formControl]="fieldControl"
	            data-test-id="one-value-select-input"
	            (selectionChange)="onChange($event.value)" [attr.aria-label]="label">
				@for (value of values; track value) {
					<mat-option [value]="value.value" [disabled]="value.disabled"
		            class="focus-inwards-dark" data-test-id="one-value-select-value">
			{{ value.label }}
		</mat-option>
				}
	</mat-select>
		}
		@if (readonly) {
			<input cdkFocusInitial #field name="input" data-test-id="one-value-select-input-readonly"
	       matInput [required]="required" type="text" [value]="getDisplayValue()" [readonly]="true">
		}
	<mat-error class="errorMessage">
		@if (fieldControl?.invalid) {
			<span class="material-icons">error</span>
		}
		<span data-test-id="one-value-editor-error-message">{{ errorMessages }}</span>
	</mat-error>
	<div class="visually-hidden" aria-hidden="true" data-test-id="selected-value">{{getDisplayValue()}}</div>
</mat-form-field>
}

<!-- autocomplete input -->
@if (isAutocompleteType) {

	<schir-int-client-autocomplete [initialFocus]="initialFocusString" [label]="label" [control]="fieldControl"
	                               [values]="values"
	                               data-test-id="one-value-autocomplete"/>

}

<!-- datepicker -->
@if (isDateType) {
	<div class="form-filed-wrapper">
		@if (!readonly) {
			<mat-form-field appearance="outline">
		<mat-label>{{ label }}</mat-label>
		<input cdkFocusInitial data-test-id="one-value-date-input" matInput [required]="required"
		       [matDatepicker]="picker"
		       [formControl]="fieldControl" (dateChange)="onChange($event.value)">
		<mat-datepicker-toggle matSuffix [for]="picker" matTooltip="Kalender öffnen"
		                       aria-label="Kalender öffnen"/>
				<mat-datepicker #picker/>
		<mat-error class="errorMessage" data-test-id="one-value-error-pattern-date">
			@if (fieldControl?.invalid) {
				<span class="material-icons">error</span>
			}
			<span data-test-id="one-value-editor-error-message">"{{ label }}" muss ein Datum sein</span>
		</mat-error>
	</mat-form-field>
		}
		@if (readonly) {
			<mat-form-field appearance="outline">
		<mat-label>{{ label }}</mat-label>
		<input cdkFocusInitial name="input" data-test-id="one-value-date-input"
		       matInput [required]="required" type="text" [value]="getDisplayValue()" [readonly]="true">
	</mat-form-field>
		}
</div>
}

<!-- checkbox -->
@if (isCheckboxType) {
	<div class="checkbox">
		@if (!readonly) {
			<mat-checkbox data-test-id="one-value-checkbox-input" color="primary" [formControl]="fieldControl"
	              [ngClass]="hideBoxShadow ? '' : 'focus-inwards-dark'"
	              [required]="required" (change)="onChange($event.checked)">
		{{ label }}
	</mat-checkbox>
		}
		@if (readonly) {
			<mat-checkbox data-test-id="one-value-checkbox-input" color="primary" [formControl]="fakeFieldControl"
	              [required]="required" aria-label="schreibgeschützt {{label}}"
	              [ngClass]="hideBoxShadow ? '' : 'focus-inwards-dark'"
	              #myself [disableRipple]="true" (click)="onlyGainFocus($event, myself)"
	              (keyup.space)="$event.preventDefault()" class="readonly">
		{{ label }}
	</mat-checkbox>
		}
</div>
}
